import { render, staticRenderFns } from "./OptionalBenefits.vue?vue&type=template&id=4566bbe7&"
import script from "./OptionalBenefits.vue?vue&type=script&lang=js&"
export * from "./OptionalBenefits.vue?vue&type=script&lang=js&"
import style0 from "./OptionalBenefits.vue?vue&type=style&index=0&id=4566bbe7&prod&lang=css&"
import style1 from "./OptionalBenefits.vue?vue&type=style&index=1&id=4566bbe7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports